import { Box, Group, Stack, Text } from "@repo/ui/core";
import { IconArrowNarrowRight } from "@repo/ui/icons";
import { motion } from "framer-motion";
import { SlideTitle } from "@components/SlideTitle";
import classes from "@styles/onsite.module.css";

type Props = {
  title: string;
  subtitle?: string;
  steps: string[];
  description: string;
};

export function FlowSlide({ title, subtitle, steps, description }: Props) {
  return (
    <Box w="100%" maw={1400} px="xl">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <Stack gap="xl">
          <SlideTitle title={title} subtitle={subtitle} />

          <Group
            gap={0}
            justify="center"
            align="center"
            wrap="wrap"
            py="xl"
            pos="relative"
          >
            {steps.map((step, i) => (
              <Group key={step} gap={0} align="center">
                <motion.div
                  initial={{ opacity: 0, scale: 0.8 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.4, delay: 0.2 + i * 0.15 }}
                >
                  <Box
                    px="xl"
                    py="lg"
                    className={
                      i === 0 ? classes.flowStepActive : classes.flowStepInactive
                    }
                  >
                    <Text
                      fw={600}
                      size="xl"
                      ta="center"
                      style={{
                        color: i === 0 ? "#fff" : "var(--mantine-color-gray-2)",
                      }}
                    >
                      {step}
                    </Text>
                  </Box>
                </motion.div>
                {i < steps.length - 1 && (
                  <motion.div
                    initial={{ opacity: 0, scaleX: 0 }}
                    animate={{ opacity: 1, scaleX: 1 }}
                    transition={{ delay: 0.3 + i * 0.15, duration: 0.3 }}
                    style={{ transformOrigin: "left" }}
                  >
                    <Box
                      mx={4}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 0,
                      }}
                    >
                      <Box
                        h={2}
                        w={24}
                        style={{
                          background:
                            "linear-gradient(90deg, rgba(255,255,255,0.15), var(--customer-accent-light))",
                          borderRadius: 1,
                        }}
                      />
                      <IconArrowNarrowRight
                        size={24}
                        style={{
                          color: "var(--customer-accent-light)",
                          marginLeft: -4,
                        }}
                      />
                    </Box>
                  </motion.div>
                )}
              </Group>
            ))}
          </Group>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.6 }}
          >
            <Text
              size="xl"
              c="dimmed"
              ta="center"
              maw={900}
              mx="auto"
              lh={1.7}
            >
              {description}
            </Text>
          </motion.div>
        </Stack>
      </motion.div>
    </Box>
  );
}
